var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0622 7.92265L12 5L6.93787 7.92265L12 10.8453L17.0622 7.92265ZM12 12L5.93787 8.5V15.5L12 19L18.0622 15.5V8.5L12 12Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDao);
export default __webpack_public_path__ + "static/media/icn-dao.0015ba31987b630340cb6f6bc66f31a7.svg";
export { ForwardRef as ReactComponent };